import moment from 'moment';
import yup from '~/config/yup';
import { PERSON_STATUS_ENUM } from '~/util/domainutils';

let schema = yup.object().shape({
  tipoPessoa: yup.string(),
  cpfCnpj: yup.string().when('tipoPessoa', {
    is: 'FÍSICA',
    then: yup.string().isValidCpf().required(),
    otherwise: yup.string().isValidCnpj().required(),
  }),
  razaoSocial: yup.string().required(),
  nomeFantasia: yup.string().required(),
  inscricaoEstadual: yup.string().required(),
  optanteSimples: yup.boolean(),
  ramoAtividadeId: yup.string().required(),
  responsavel: yup.string().required(),
  estado: yup.string().required(),
  cep: yup.string().required(),
  cidade: yup.string().required(),
  bairro: yup.string().required(),
  endereco: yup.string().required(),
  complemento: yup.string(),
  pontoReferencia: yup.string(),
  telefone1: yup.string().required(),
  telefone2: yup.string(),
  email: yup.string().email('Email inválido').required(),
  cnae: yup.string(),
  dataCadastro: yup.string(),
  microempresa: yup.boolean(),
  retemICMS: yup.boolean(),
  segmentos: yup.boolean(),
  status: yup.string().required(),
  statusChave: yup.string().required(),
  prazoRenovacaoChave: yup.string(),
  revendaId: yup.string().nullable(),
});

export const defaultValues = {
  tipoPessoa: 'FÍSICA',
  cpfCnpj: '',
  razaoSocial: '',
  nomeFantasia: '',
  inscricaoEstadual: '',
  optanteSimples: false,
  ramoAtividadeId: '',
  responsavel: '',
  estado: '',
  cep: '',
  cidade: '',
  bairro: '',
  endereco: '',
  complemento: '',
  pontoReferencia: '',
  telefone1: '',
  telefone2: '',
  email: '',
  cnae: '',
  dataCadastro: moment().format('YYYY-MM-DD'),
  microempresa: false,
  retemICMS: false,
  segmentos: false,
  status: PERSON_STATUS_ENUM.NOT_BLOCKED.value,
  statusChave: PERSON_STATUS_ENUM.NOT_BLOCKED.value,
  prazoRenovacaoChave: '30',
  revendaId: '',
};

export default schema;
